import { useState } from "react";
import "./WelcomeScreen.css";
import "../../components/css/animations.css";
import blackArrow from "../../assets/images/black-arrow.svg";
import whiteArrow from "../../assets/images/white-arrow.svg";
import appIcon from "../../assets/images/welcome-screen-sabe-logo.svg";
import { useNavigate } from "react-router-dom";
import ROUTE_PATHS from "../../utils/routePaths";

const WelcomeScreen = () => {
  const navigate = useNavigate();
  const [isHovered, setIsHovered] = useState(false);

  const handleReadyToScaleClick = () => {
    const storedData = localStorage.getItem("userProfileData");
    if (storedData) {
      const userProfileData = JSON.parse(storedData);
      if (userProfileData?.is_verified) {
        navigate(ROUTE_PATHS.WSM_INITIAL_LOAD, { replace: true });
      } else {
        navigate(ROUTE_PATHS.WSM_SIGNIN, { replace: true });
      }
    } else {
      navigate(ROUTE_PATHS.WSM_SIGNIN, { replace: true });
    }
  };

  return (
    <div className="wms-mobile-container">
      <div className="welcome-screen-container">
        <img src={appIcon} className="welcome-screen-app-icon" alt="logo" />
        <div className="welcome_screen_bottom_container">
          <div className="page-title-container">
            <span>Built</span>
            <span>for</span>
            <span style={{ color: "#ff6b35" }}>More .</span>
          </div>
          <div
            className="welcome-screen-scale-container"
            onClick={handleReadyToScaleClick}
          >
            <div
              className="welcome-screen-scale-sub-container"
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            >
              READY TO SCALE
              <img
                src={isHovered ? whiteArrow : blackArrow}
                className="welcome-screen-scale-arrow-icon"
                alt="logo"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WelcomeScreen;
